import React from "react";
import { AdditionalConfiguration, InfobuttonTextsContainer, PublicConfigType, UserRoleType } from "./types/admin/User";
import { Classifier } from "./util/classifierManager";

const CurrentUserContext = React.createContext<{
  id: number;
  name: string;
  usageRights: UserRoleType[];
  representationRights: number[];
  representationRightClassifiers: Classifier[];
  interestOrganisations: number[];
  interestOrganisationClassifiers: Classifier[];
  isLoggedIn: boolean;
  authenticate: () => void;
  additionalConfiguration?: AdditionalConfiguration;
  infobuttonTexts: InfobuttonTextsContainer;
  publicConfig: PublicConfigType;
  updateInfotexts: Function;
}>(undefined!);

export const CurrentUserProvider = CurrentUserContext.Provider;
export const CurrentUserConsumer = CurrentUserContext.Consumer;

export default CurrentUserContext;
